import React from 'react';
import cn from 'classnames';
import styles from './DottedBorderBackground.module.scss';

const DottedBorderBackground = ({
  className,
  transparent = false,
  removePadding = false,
  ...props
}) => {
  return (
    <div
      {...props}
      className={cn(styles.root, className, {
        [styles.lightBg]: !transparent,
        [styles.transparentBg]: transparent,
        [styles['p-8']]: !removePadding,
      })}
    />
  );
};

export default DottedBorderBackground;
